<!-- Карточка контрагента заказа в read-only блоке заказа -->
<template>
  <button class="order-counterparty-card" type="button" @click="$emit('open')">
    <span class="order-counterparty-card__role" :class="roleClass">
      {{ roleLabel }}
    </span>
    <span class="order-counterparty-card__name">
      {{ name }}
    </span>
  </button>
</template>

<script>
export default {
  name: "OrderCounterpartyCard",
  props: {
    roleLabel: {
      type: String,
      required: true,
    },
    roleClass: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
  },
  emits: ["open"],
};
</script>

<style scoped>
.order-counterparty-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px;
  color: inherit;
  text-align: left;
  background: rgb(240, 240, 240);
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.order-counterparty-card:hover {
  background: #e6f5ed;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.order-counterparty-card__role {
  display: inline-block;
  flex: 0 0 auto;
  padding: 5px 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  background-color: #6c757d;
  border-radius: 4px;
}

.order-counterparty-card__role.role-customer {
  background-color: #9333ea;
}

.order-counterparty-card__role.role-carrier {
  background-color: #1d4ed8;
}

.order-counterparty-card__role.role-shipper {
  background-color: #16a34a;
}

.order-counterparty-card__role.role-consignee {
  background-color: #f59e0b;
}

.order-counterparty-card__role.role-forwarder {
  background-color: #0d9488;
}

.order-counterparty-card__name {
  color: var(--color-dark);
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

@media (max-width: 1200px) {
  .order-counterparty-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .order-counterparty-card__name {
    text-align: left;
  }
}
</style>
